module.exports = __webpack_public_path__ + "static/media/Dell UltraSharp 27\".d4548a1c.png";